import React from 'react';
import { Tag } from '@gerdau/hefesto/Tag';

enum EDeliveryStatus {
  NOT_CONFIRMED = 'not_confirmed',
  ON_TIME = 'on_time',
  OVERDUE = 'overdue',
  BILLED = 'billed'
}

interface IDeliveryStatusColumnProps {
  data?: string;
  countOverdue?: boolean;
}

const DeliveryStatusColumn: React.FC<IDeliveryStatusColumnProps> = ({
  data,
  countOverdue
}) => {
  if (!data) {
    return null;
  }

  const deliveryStatus = [
    {
      status: EDeliveryStatus.OVERDUE,
      description: 'Com atraso',
      variantStatus: 'warning'
    },
    {
      status: EDeliveryStatus.ON_TIME,
      description: 'Dentro do prazo',
      variantStatus: 'neutral'
    },
    {
      status: EDeliveryStatus.BILLED,
      description: 'Faturado',
      variantStatus: 'success'
    },
    {
      status: EDeliveryStatus.NOT_CONFIRMED,
      description: 'Aguardando confirmação',
      variantStatus: 'neutral'
    }
  ].find((item) => data.includes(item.description));

  if (countOverdue) {
    return <Tag variant="warning">{data}</Tag>;
  }

  if (!deliveryStatus) {
    return <Tag variant="neutral">{data}</Tag>;
  }

  return (
    <Tag variant={deliveryStatus.variantStatus}>
      {deliveryStatus.description}
    </Tag>
  );
};

export default DeliveryStatusColumn;
